import { styled } from "@mui/material/styles";
import ButtonGroup from "@mui/material/ButtonGroup";

export const GroupWrapper = styled(ButtonGroup)`
  margin-right: 30px;
`;
